export default __webpack_public_path__ + "bc88a54c5d8649369352d66bb77bda46.svg";